module.exports = __webpack_public_path__ + "posture/static/img/head_sideway_right.2901530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/head_sideway_right.png
// module id = REHF
// module chunks = 1